export class AssignedToTeamDto{
    public TeamId: number | undefined
    public Name: string | undefined
}